import axios from 'axios';

const API = axios.create({
  baseURL: process.env.VUE_APP_API_BASE_URL,
  headers: {
    'Content-Type': 'application/json;charset=UTF-8',
    "Access-Control-Allow-Origin": true,
    "Access-Control-Allow-Credentials": true,
  }
});

const baseURL = process.env.VUE_APP_API_BASE_URL;

export default {API, baseURL};
